import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "advertising" }
const _hoisted_2 = { class: "advertising__summary" }
const _hoisted_3 = {
  key: 0,
  class: "advertising__empty advertising__empty--loading"
}
const _hoisted_4 = {
  key: 1,
  class: "advertising__empty"
}
const _hoisted_5 = {
  key: 2,
  class: "advertising__rows"
}

import { ref } from 'vue';
import AdvertisingRow from './AdvertisingRow.vue';
import {
  useBaseAsync,
  type HpsfirProFormItem,
} from 'hpsfir-managebase-ui';

import { useApi } from '@/hooks/useApi';
import { ElMessage } from 'element-plus';


export default /*@__PURE__*/_defineComponent({
  __name: 'Advertising',
  props: {
    position: {}
  },
  setup(__props: any) {

const loading = ref(false);

const props = __props;

const addDialogRef = ref<{ reset?(): void; setOneFormState?(name: string, value: unknown): void }>();

const rowOp: {
    value: any;
    label: string;
}[] = [
  {
    label: '轮播',
    value: 'carousel',
  },
  {
    label: '均匀分布',
    value: 'distribute',
  },
];

const items: HpsfirProFormItem[] = [
  {
    type: 'select',
    label: '类型',
    name: 'type',
    options: rowOp,
    rule: [{ required: true }],
  },
];

const advertisingRowDatas = ref<any[]>([]);

function withTimeout<T>(promise: Promise<T>, message = '广告位数据加载超时') {
  return Promise.race([
    promise,
    new Promise<T>((resolve, reject) => {
      void resolve;
      window.setTimeout(() => reject(new Error(message)), 15000);
    }),
  ]);
}

const init = useBaseAsync(async() => {
  try {
    loading.value = true;
    const res = await withTimeout(useApi().advertisingApi.listAdvertisingRowadvertising({
      conditions: {
        position: props.position,
      },
    }));
    advertisingRowDatas.value = res?.data?.data || [];
  } catch (error) {
    console.log(error);
    ElMessage.error(error instanceof Error ? error.message : '广告位数据加载失败');
  } finally {
    loading.value = false;
  }
});

const handleAdd = useBaseAsync(async(data: any) => {
  try {
    await withTimeout(useApi().advertisingApi.addAdvertisingRowadvertising({
      advertisingRowAdminVo: {
        position: props.position,
        type: data.type,
        sequence: advertisingRowDatas.value.length + 1,
      },
    }), '添加广告行超时');
    ElMessage.success('添加成功');
    init();
  } catch (error) {
    console.log(error);
    ElMessage.error(error instanceof Error ? error.message : '添加广告行失败');
  }
});

init();

return (_ctx: any,_cache: any) => {
  const _component_Plus = _resolveComponent("Plus")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_HpsfirButton = _resolveComponent("HpsfirButton")!
  const _component_HpsfirProForm = _resolveComponent("HpsfirProForm")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[3] || (_cache[3] = _createElementVNode("div", null, [
        _createElementVNode("div", { class: "advertising__summary-title" }, "广告位内容"),
        _createElementVNode("div", { class: "advertising__summary-desc" }, "按展示顺序维护广告行和广告条目，支持轮播和均匀分布两种展示方式。")
      ], -1)),
      _createVNode(_component_HpsfirButton, {
        class: "advertising__add-btn",
        onClick: _cache[0] || (_cache[0] = () => addDialogRef.value?.showDialog())
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_icon, null, {
            default: _withCtx(() => [
              _createVNode(_component_Plus)
            ]),
            _: 1
          }),
          _cache[2] || (_cache[2] = _createTextVNode(" 添加一行 ", -1))
        ]),
        _: 1
      })
    ]),
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [...(_cache[4] || (_cache[4] = [
          _createElementVNode("div", { class: "advertising__empty-icon" }, "...", -1),
          _createElementVNode("div", { class: "advertising__empty-title" }, "广告位加载中", -1),
          _createElementVNode("div", { class: "advertising__empty-desc" }, "正在获取广告位数据，请稍候。", -1)
        ]))]))
      : (!advertisingRowDatas.value.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [...(_cache[5] || (_cache[5] = [
            _createElementVNode("div", { class: "advertising__empty-icon" }, "AD", -1),
            _createElementVNode("div", { class: "advertising__empty-title" }, "暂无广告行", -1),
            _createElementVNode("div", { class: "advertising__empty-desc" }, "点击“添加一行”创建轮播或均匀分布广告位。", -1)
          ]))]))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(advertisingRowDatas.value, (advertisingRow, inx) => {
              return (_openBlock(), _createBlock(AdvertisingRow, {
                key: advertisingRow.id,
                "row-data": advertisingRow,
                "is-first": inx === 0,
                "is-last": inx === advertisingRowDatas.value.length - 1,
                onChange: _cache[1] || (_cache[1] = () => _unref(init)())
              }, null, 8, ["row-data", "is-first", "is-last"]))
            }), 128))
          ])),
    _createVNode(_component_HpsfirProForm, {
      "is-dialog": true,
      ref_key: "addDialogRef",
      ref: addDialogRef,
      title: "添加一行",
      items: items,
      onOk: _unref(handleAdd)
    }, null, 8, ["onOk"])
  ]))
}
}

})